export const isAccessFlow = (project_id) => {
    var res = false;
    /* PROJECTS
    *  LOCAL            - 766f8e7f885b4188969bb8bcbc96fce4
    *  Dahiana PRE      - 7b4cd09269de44a6b6c409d1ea3fe5e6
    *  PCENTRIBALC PRE  - 0dd7578787e0415ca26d74849404bf19
    *  DAHIANA PRO      - a8fe336978134d62b7f1e40d9ac549f5
    *  PCENTRIBALC PRO  - c851dd852c9b4bafb23c149b3c4cabfa
    */
    ['766f8e7f885b4188969bb8bcbc96fce4', '7b4cd09269de44a6b6c409d1ea3fe5e6', '0dd7578787e0415ca26d74849404bf19', 'a8fe336978134d62b7f1e40d9ac549f5', 'c851dd852c9b4bafb23c149b3c4cabfa'].forEach(id => {
        if (project_id === id) {
            res = true;
        }
    })

    return res;
}